<template>
  <AffiliateGalleryPage />
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import AffiliateGalleryPage from '@/components/AffiliateGallery.vue'

export default {
  name: 'AffiliateGallery',
  components: {
    AffiliateGalleryPage
  }
}
</script>
